import React from 'react'
import { useLazyQuery } from '@apollo/react-hooks'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

import { Button, Input } from '@mui/material'
// import { VoucherType } from '../../types'
import { EXPORT_VOUCHERS } from './gql'
import Loader from '../Loader'


const ExportVouchers = () => {
  // start of the year date
  const startOfYear = new Date(new Date().getFullYear(), 0, 1)

  const jwtToken = localStorage.getItem('jwtToken') || ''
  const [dateFrom, setDateFrom] = React.useState(startOfYear.toISOString())
  const [dateTo, setDateTo] = React.useState(new Date().toISOString())

  // const [skip, setSkip] = React.useState(0)
  // const [take, setTake] = React.useState(150)

  const [fetchData, { loading, error, data }] = useLazyQuery(EXPORT_VOUCHERS)

  //if (toDate && fromDate) {

  // call this endpoint when the toDate and fromDate are set
  const fetchVouchers = async () => {
    fetchData({
      variables: { input: { dateTo, dateFrom, skip: 0, take: 150 } },
      context: { headers: { authorization: jwtToken } },
    })
  }
  //}

  if (error) return <p>ERROR</p>

  return (
    <Paper square elevation={0}>
      <Typography variant="h6" component="div">
        <Input
          type="date"
          defaultValue={startOfYear.toISOString().split('T')[0]}
          onChange={(e) => setDateFrom(new Date(e.target.value).toISOString())}
          style={{ margin: '10px' }}
        />
        {' - '}
        <Input
          type="date"
          defaultValue={new Date().toISOString().split('T')[0]}
          onChange={(e) => setDateTo(new Date(e.target.value).toISOString())}
          style={{ margin: '10px' }}
        />
        {
          /*
          TODO: Add more filters here
           like status, department, pay to, created by, claimed by, financial year
          */
        }
        <Button
          variant="contained"
          color="primary"
          onClick={() => fetchVouchers()}
          disabled={!dateTo || !dateFrom}
          style={{ margin: '10px' }}
        >
          Export
        </Button>
      </Typography>
      {loading && <Loader />}
      {data && data.export.signedLink && (
        <a href={data.export.signedLink}>Download</a>
      )}
    </Paper>
  )
}

export default ExportVouchers